import localforage from 'localforage'

localforage.config({
    driver      : localforage.INDEXEDDB,
    name        : 'horus',
    version     : 1.0,
    storeName   : 'root'
})

export default localforage